import api from 'api';

type GetMaterialsType = {id: number | string}

export const getMaterials = async ({ id }:GetMaterialsType) => api().get(`/materials/${id}`);

export const createMaterials = async ({ data }) => api().post('/materials', data);

export const updateMaterials = async ({ id, data }) => api().put(`/materials/${id}`, data);
